 // const BASE_URL="http://192.168.0.11/"
 //const BASE_URL_IMG="http://192.168.0.12/easy_erp_multi_jwt/" 





 const BASE_URL="https://payment.tatadavjoda.com/"
 const BASE_URL_IMG="https://npmapi.ubkerp.com/"

export const ConfigFile = {
  // BaseUrl: `${BASE_URL}easy_erp/api`,
  // IconUrl: `${BASE_URL}easy_erp/icons`,
  // ImageUrl: `${BASE_URL}easy_erp/uploads`,
  // LocalUrl: "http://localhost:3001/",

  
  BaseUrl: `${BASE_URL_IMG}api`,
  IconUrl: `${BASE_URL_IMG}icons`,
  ImageUrl: `${BASE_URL_IMG}uploads`,
  studentImage: `https://image.ubkerp.com/uploads/`,
  LocalUrl: BASE_URL,

};
